<template>
  <div>

   <!-- <div style="background: yellow; padding: 10px; margin: 10px 0;">
      <strong>DEBUG:</strong><br>
      branchId: {{ branchId }}<br>
      departmentType: {{ departmentType }}<br>
      isOncologyDepartment: {{ isOncologyDepartment }}<br>
      Should show: {{ branchId && isOncologyDepartment }}
    </div>
     END DEBUG -->

    <!--Treatment History-->

    <!--Treatment History - Only show for Oncology-->
    <div v-if="branchId && allowedDepartmentsForTreatmentHistory.includes(departmentType)">
  <div>
    <div
      class="group-title d-flex align-items"
      v-b-toggle.collapse-treatment
    >
      <div class="col-md-6">
        <span class="when-opened mr-2">
          <b-icon icon="chevron-up" />
        </span>
        <span class="when-closed mr-2">
          <b-icon icon="chevron-down" />
        </span>
        Treatment History
        <span class="badge badge-primary">
          {{ localTreatmentHistory.length }}
        </span>
      </div>
      <div class="col-md-6 treatment-dropdown-wrapper">
        <b-dropdown
          size="sm"
          id="dropdown-form"
          text="Choose previous treatment"
          ref="dropdown"
          variant="outline"
          class="form-control treatment-dropdown"
        >
          <b-dropdown-form class="treatment-dropdown-form">
            <b-form-checkbox
              v-for="treatment in availableTreatments"
              :key="treatment.id"
              :id="`chk_treatment_` + treatment.id"
              @change="(checked) => updateHistory(checked, treatment)"
            >
              {{ treatment.name }}
            </b-form-checkbox>
          </b-dropdown-form>
        </b-dropdown>
      </div>
    </div>
  </div> 

  <b-collapse visible id="collapse-treatment"  v-if="hideTreatmentResultCheckbox && departmentType !== 'emergency' ">
    <div>
      <div
        class="treatment-history-item"
        v-for="(history, index) in localTreatmentHistory"
        :key="index"
      >
        <span class="treatment-history-name">
          <strong>{{ map[index] }}</strong> {{ history.name }}
        </span>
        <span
          class="icon-remove"
          role="button"
          @click="removeHistory(history)"
        >
          <b-icon-x></b-icon-x>
        </span>

        <div 
          class="form-group history-line--tolerated mb-0" 
          v-if="hideTreatmentResultCheckbox"
        >
          <div class="row mt-2">
            <label class="col-6">
              <span>Adverse Events</span>
            </label>

            <div class="col-6" style="padding-left: 0;">
              <v-select
                :id="`WellTolerated_${index}`"
                :options="extendedWellTolerated"
                label="value"
                code="id"
                @input="(e) => updateToleratedOption(e, history)"
                placeholder="Select Option"
              >
              </v-select>
            </div>
          </div>
          <div class="row mt-2">
            <label class="col-6">
              <span>Best Response</span>
            </label>

            <div class="col-6" style="padding-left: 0;">
              <v-select
                :id="`WasEffective_${index}`"
                :options="extendedWasEffective"
                label="Text"
                code="Line"
                v-model="history.wasEffective"
                placeholder="Select Option"
              >
              </v-select>
            </div>
          </div>
        </div>
      </div>
    </div>
  </b-collapse>
</div>
    <!--//Treatment History-->

    <app-question-group
      v-for="(group, index) of localGroups"
      :key="index"
      :group="group"
      :currentQuestionId="currentQuestionId"
      @currentQuestion="setCurrentQuestion"
      @setAnswer="setAnswer"
    />
  </div>
</template>

<script lang="ts">
import { Prop, Watch, Component, Vue } from "vue-property-decorator";
import { Answer } from "@/entities/questionaire/answers/Answer";
import { Treatment } from "@/entities/Treatment";
import { Group } from "@/entities/questionaire/Group";
import { HttpHandler } from "@/http/HttpHandler";
import AppQuestionGroup from "@/components/questionnaire/AppQuestionGroup.vue";
import "vue-select/dist/vue-select.css";
import { Property } from "@/entities/questionaire/Property";
import store from "@/store/index";

@Component({
  components: {
    AppQuestionGroup: AppQuestionGroup,
  },
})
export default class AppQuestionList extends Vue {
  private httpHandler: HttpHandler = new HttpHandler(store);
  private error: boolean = false;
  hasToBeToleratedLocal: { Line: string; Text: string } | null = null;
  

departmentType: string = '';
   branchName: string = '';
   allowedDepartmentsForTreatmentHistory:string[] = ['oncology', 'antibiotic'];
  @Prop()
  branchId!: number | null;
  private localBranchId: number | null = null;

  @Prop()
  questionNo!: number | null;
  private localQuestionNo: number | null = null;

  @Prop()
  questionCount!: number | null;
  private localQuestionCount: number | null = null;

  @Prop()
  groups!: Group[] | null;

  @Prop()
  public localGroups!: Group[];

  @Prop()
  answers!: Answer[] | null;
  private localAnswers: Answer[] = [];

  @Prop()
  treatmentHistory!: Treatment[] | null;
  public localTreatmentHistory: Treatment[] = [];

  @Prop()
  currentQuestionId!: number | null;

  @Prop()
  private localQuestions!: Property[];

  private availableTreatments: Treatment[] = [];

  private map: any[] = ["1st", "2nd", "3rd", "4th", "5th"];

  private hideTreatmentResultCheckbox: boolean = false;
  
  extendedWellTolerated: Array<{id: Treatment["wellTolerated"], value: string}> = [
    { id: "NoAE", value: "No AE" },
    { id: "Grade1AE", value: "Grade 1 AE" },
    { id: "Grade2AE", value: "Grade 2 AE" },
    { id: "Grade3AE", value: "Grade 3 AE" },
    { id: "Grade4AE", value: "Grade 4 AE" },
  ];

  extendedWasEffective: Array<Treatment["wasEffective"]> = ['PD', 'SD', 'PR', 'CR'];

  filteredQuestions: Property[] = [];

  private async fetchBranchDetails(branchId: number): Promise<void> {
  try {
    console.log('=== fetchBranchDetails START ===');
    console.log('branchId:', branchId);
    
    const branch = await this.httpHandler.getBranchById(branchId);
    console.log('Branch object:', branch);
    console.log('Branch departmentType:', branch.departmentType);
    console.log('Branch as any departmentType:', (branch as any).departmentType);
    
    // Get departmentType from API
    const apiDepartmentType = (branch as any).departmentType;
    console.log('apiDepartmentType:', apiDepartmentType);
    
    if (apiDepartmentType) {
      this.departmentType = apiDepartmentType;
      console.log('✅ Department type set from API:', this.departmentType);
    } else {
      console.log('⚠️ No departmentType from API, using fallback');
      // Fallback: Extract from branch name
      const branchName = branch.name || '';
      if (branchName.includes('/')) {
        this.departmentType = branchName.split('/')[0].trim();
      } else {
        this.departmentType = branchName;
      }
      console.log('Department type fallback:', this.departmentType);
    }
    
    this.branchName = branch.name || '';
    console.log('Final departmentType:', this.departmentType);
    console.log('isOncologyDepartment computed:', this.isOncologyDepartment);
    console.log('=== fetchBranchDetails END ===');
  } catch (error) {
    console.warn('Could not fetch branch details:', error);
  }
}

async created(): Promise<void> {
  this.localBranchId = this.branchId;
  this.localAnswers = [...(this.answers ?? [])];
  this.localTreatmentHistory = [...(this.treatmentHistory ?? [])];

  this.$emit('update:localGroups', [...(this.groups ?? [])]);

  // ✅ ADD THIS - Fetch branch details first
  if (this.branchId) {
    await this.fetchBranchDetails(this.branchId);
  }

  await this.updateGroups();
}

@Watch("branchId")
async updateTreatmentResultCheckbox() {
  if (this.branchId) {
    // ✅ ADD THIS - Fetch department type when branch changes
    await this.fetchBranchDetails(this.branchId);
    
    const { name } = await this.httpHandler.getBranchById(this.branchId);

    if (
      (name.includes('SCLC') && name.includes('Extensive Disease')) ||
      (name.includes('NSCLC') && name.includes('Stage IV'))
    ) {
      this.hideTreatmentResultCheckbox = true;
    } else {
      this.hideTreatmentResultCheckbox = false;
    }
  }
}

  mounted() {
    this.$events.on("onSetPreviousQuestion", this.setPreviousQuestion);
    this.$events.on("onSetNextQuestion", this.setNextQuestion);
    this.$events.on("throwError", (id) => {
      this.error = true;
    });
  }

  beforeDestroy() {
    this.$events.off("onSetPreviousQuestion");
    this.$events.off("onSetNextQuestion");
    this.$events.off("throwError");
  }

  setCurrentQuestion(data: any) {
    if (!data) {
      this.$emit("currentQuestion", data);
      return;
    }

    this.filteredQuestions = [];

    for (let i = 0; i < this.localGroups.length; i++) {
      for (let j = 0; j < this.localGroups[i].properties.length; j++) {
        if (!this.localGroups[i].properties[j].isHidden) {
          this.filteredQuestions.push(this.localGroups[i].properties[j]);
        }
      }
    }

    const currentIdx = this.filteredQuestions.findIndex(
      (x) => x.id == data.id
    );
    this.localQuestionNo = currentIdx;
    this.$emit("currentQuestion", data);
    this.$emit("currentQuestionIndex", currentIdx);

    if (window.innerWidth <= 768) {
      this.$nextTick(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });
    }
  }

 

 setAnswer(answer: Answer) {
    if (answer) {
      const newAnswers = [...this.localAnswers];
      const index = newAnswers.findIndex(
        (x) => x.PropertyId === answer.PropertyId
      );

      if (index > -1 && !answer.isEmpty()) {
        newAnswers.splice(index, 1, answer);
      } else if (index > -1 && answer.isEmpty()) {
        newAnswers.splice(index, 1);
      } else {
        newAnswers.push(answer);
      }
      this.localAnswers = newAnswers.filter((x) => !x.isEmpty());
    }

    this.filteredQuestions = [];

    for (let i = 0; i < this.localGroups.length; i++) {
      for (let j = 0; j < this.localGroups[i].properties.length; j++) {
        if (!this.localGroups[i].properties[j].isHidden) {
          this.filteredQuestions.push(this.localGroups[i].properties[j]);
        }
      }
    }

    this.setNextQuestion(answer.PropertyId);
  }
  


  setNextQuestion(answerQuestionId: number): void {
    if ((!answerQuestionId || answerQuestionId == undefined) && (this.questionNo != undefined && this.questionNo > -1)) {
      const nextIdx = this.questionNo + 1;
      const nextQuestion = this.filteredQuestions[nextIdx];
      this.setCurrentQuestion(nextQuestion);
      this.$emit("currentQuestionIndex",  nextIdx);
      return;
    }

    const currentIdx = this.filteredQuestions.findIndex(
      (x) => !x.selectedAnswer || x.selectedAnswer.isEmpty()
    );
    if (currentIdx < this.filteredQuestions.length) {
      const nextId = currentIdx;
      const nextQuestion = this.filteredQuestions[nextId];
      this.$emit("currentQuestionIndex",  nextId);
      this.setCurrentQuestion(nextQuestion);
    }
  }

  setPreviousQuestion(): void {
    if (this.currentQuestionId == -1) {
      this.setCurrentQuestion(
        this.filteredQuestions[this.filteredQuestions.length - 1]
      );
      return;
    }

    const currentIdx = this.filteredQuestions.findIndex(
      (x) => x.id == this.currentQuestionId
    );
    if (currentIdx < this.filteredQuestions.length) {
      const prevId = currentIdx - 1;
      this.setCurrentQuestion(this.filteredQuestions[prevId]);
    }
  }

  get canAddNewHistory() {
    return !this.localTreatmentHistory.find((treat) => treat.id === 0);
  }
  get isOncologyDepartment(): boolean {
    const dept = (this.departmentType || '').toLowerCase().trim();
    return dept.includes('oncology') || dept.includes('onkologie');
  }

  updateHistory(checked: boolean, history: Treatment) {

    console.log ("update history");
    if (!checked) {
      this.localTreatmentHistory = this.localTreatmentHistory.filter(
        (item) => item.id != history.id
      );
      
    } else {

      this.localTreatmentHistory.push(history);
    }
    this.$store.commit('setDeleteExcludeRecommendations', true);
    this.$store.commit('setDeleteStore', true);
  }

  updateToleratedOption(event: any, history: Treatment) {
    if (!event) {
      this.localTreatmentHistory.find(item => item.id === history.id)!.wellTolerated = undefined;
    } else {
      this.localTreatmentHistory.find(item => item.id === history.id)!.wellTolerated = event.id;
    }
    this.$store.commit('setDeleteExcludeRecommendations', true);
    this.$store.commit('setDeleteStore', true);
  
  }

  removeHistory(history: Treatment) {
    console.log("remove history");
    this.localTreatmentHistory = this.localTreatmentHistory.filter(
      (item) => item.id != history.id
    );

    const checkbox = document.getElementById(
      "chk_treatment_" + history.id
    ) as HTMLInputElement | null;

    if (checkbox != null) {
      checkbox.checked = false;
    }
    this.$store.commit('setDeleteExcludeRecommendations', true);
    this.$store.commit('setDeleteStore', true);
  }

  async updateGroups() {
    this.$emit('update:localGroups', this.localBranchId
      ? await this.httpHandler.getGroupsByBranchId(this.localBranchId)
      : []);
    this.localAnswers = [];

    let branchTreatments = this.localBranchId
      ? await this.httpHandler.getToolsByBranchId(this.localBranchId)
      : [];

    this.availableTreatments = branchTreatments.map((b) => {
      return new Treatment(b.id, b.name);
    });

    this.localTreatmentHistory = [];

    const localQuestions: Property[] = [];

    if (this.localGroups) {
      for (let i = 0; i < this.localGroups.length; i++) {
        var group = this.localGroups[i];
        group.properties.forEach((p) => {
          localQuestions.push(p);
        });
      }
      this.$emit('update:localQuestions', localQuestions)
      this.localQuestionCount = localQuestions.length;
    }

    if (this.localQuestions && localQuestions.length > 0) {
      this.setCurrentQuestion(localQuestions[0]);
    }
  }

  @Watch("localQuestionNo")
  onLocalQuestionNoChanged() {
    this.$emit("update:questionNo", this.localQuestionNo);
  }
  @Watch("localQuestionCount")
  onLocalQuestionCountChanged() {
    this.$emit("update:questionCount", this.localQuestionCount);
  }

  @Watch("branchId")
  onBranchIdChanged() {
    this.localBranchId = this.branchId;
  }
  @Watch("localBranchId")
  onLocalBranchIdChanged() {
    this.updateGroups();
    this.$emit("update:branchId", this.localBranchId);
  }
  @Watch("groups")
  onGroupsChanged() {
    this.$emit('update:localGroups', this.groups ?? [])
    // this.localGroups = this.groups ?? [];
  }
  @Watch("localGroups")
  onLocalGroupsChanged() {
    this.$emit("update:groups", this.localGroups);
  }

  @Watch("answers")
  onAnswersChanged() {
    this.localAnswers = this.answers ?? [];
  }

  @Watch("localAnswers")
  onLocalAnswersChanged() {
    this.$emit("update:answers", this.localAnswers);
  }

  @Watch("localTreatmentHistory", { deep: true })
  onLocalHistoryChanged() {
    this.$emit("update:treatmentHistory", this.localTreatmentHistory);
  }
}
</script>

<style lang="scss" scoped>
.collapsed > .when-opened,
:not(.collapsed) > .when-closed {
  display: none;
}

.badge-primary {
  background: #41d976;
  border-radius: 23px;
  font-size: 12px;
}

.treatment-dropdown-wrapper {
  margin-left: auto;
  width: 343px;

  .treatment-dropdown {
    background: #ffffff;
    font-size: 14px;
    height: 30px;
    padding: 0;
  }

  .treatment-dropdown-form {
    font-size: 14px;
    max-height: 480px;
    overflow-x: hidden;
    overflow-y: scroll;
  }
}

.treatment-history-item {
  position: relative;
  background: #edf1f6;
  border-radius: 15px;

//  font-family: "Inter";
  font-family: 'Albert Sans', sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 15px;

  padding: 5px 10px;
  width: 100%;

  color: #111111;
  margin-bottom: 4px;

  .treatment-history-name {
    padding-right: 10px;
    display: block;
  }

  .icon-remove {
    font-size: 16px;
    float: right;
    position: absolute;
    top: 5px;
    right: 5px;
  }
}

.align-items {
  flex-direction: column;
  align-items: flex-start !important;
}

.treatment-dropdown-wrapper {
  margin-left: 0;
  width: 255px;
  padding-left: 0;
  margin-top: 5px;
}

.additional-option-label::before {
  border-color: #adb5bd !important;
  background-color: #fff !important;
}

.custom-control-input:checked~.additional-option-label::after {
  color: #fff;
  border-color: #007bff;
  background-color: #007bff;
  border-radius: 0.25rem;
}

label {
  padding-top: 5px;
}

@media  (min-width: 768px) and (max-width: 992px) {
  .col-md-6 {
    flex: 25%;
  }
}

@media only screen and (min-width: 768px) {
  .col-md-6 {
    max-width: none;
  }
}

@media only screen and (min-width: 992px) {
  .col-md-6 {
    max-width: none;
  }
}

@media only screen and (min-width: 1200px) {
  .col-md-6 {
    max-width: none;
  }

  .align-items {
    flex-direction: row;
    align-items: center!important;
  }

  .treatment-dropdown-wrapper {
    margin-left: auto;
    width: 255px;
    padding-left: 0;
    margin-top: 0;
  }
}
</style>
